import { createContext, useContext } from "react";

const DEFAULT_VALUE = {
  adState: null, // Or simply null
  setAdState: () => {},
  adSettings: null,
  shouldShowAds: false,
  transitionToAd: () => {},
  isAdsInitialized: true, // Say it's "initialized" to not block anything
  isIrisReady: false
};

export const OrcaAdsContext = createContext(DEFAULT_VALUE);

export const useOrcaAdsContext = () => useContext(OrcaAdsContext);
